export enum FormComponent {
    welcome = 1,
    planSelect,
    business,
    financial,
    bankSelection,
    verification,
    payment,
    finish,
    coverage,
    upgrade,
    cancel,
    partners,
    brokers,
    ww,
    lendio,
    connectBank,
    SBAForm,
    termsAndConditions,
    manageLoan
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/state/FormsState.ts